/**
=========================================================
* Material Dashboard 2 PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import { URL_API } from "config";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

const defaultObj = {
  email: "",
};
function Password() {
  const [reset, setReset] = useState(defaultObj);
  const [send, setSend] = useState(false);

  const navigate = useNavigate();

  const resendEmail = async () => {
    await axios.post(URL_API + `/user/recovery-password`, {
      email: reset.email,
    });

    setSend(true);
  }

  function handleChange(event) {
    const { name, value } = event.target;
    setReset((account) => {
      return {
        ...account,
        [name]: value,
      };
    });
  }

  return (
    <BasicLayout image={bgImage}>
      {!send ? (
        <Card>
          <MDBox
            variant="gradient"
            bgColor="success"
            borderRadius="lg"
            coloredShadow="success"
            mx={2}
            mt={-3}
            p={2}
            mb={1}
            textAlign="center"
          >
            <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
              Recuperar Senha
            </MDTypography>
          </MDBox>
          <MDBox pt={4} pb={3} px={3}>
            <MDBox component="form" role="form">
              <MDBox mb={2}>
                <MDInput
                  type="email"
                  label="Email"
                  name="email"
                  value={reset.email}
                  onChange={handleChange}
                  fullWidth
                />
              </MDBox>
              <MDBox mt={4} mb={1}>
                <MDButton
                  variant="gradient"
                  color="light"
                  onClick={resendEmail}
                  fullWidth
                >
                  Enviar Email
                </MDButton>
              </MDBox>
              <MDBox mt={3} mb={1} textAlign="center">
                <MDTypography variant="button" color="text">
                  <MDTypography
                    onClick={() => navigate('/auth/login')}
                    variant="button"
                    color="info"
                    fontWeight="medium"
                    textGradient
                    style={{ cursor: "pointer" }}
                  >
                    Fazer Login
                  </MDTypography>
                </MDTypography>
              </MDBox>
            </MDBox>
          </MDBox>
        </Card>
      ) : (
        <Card>
          <MDBox
            variant="gradient"
            bgColor="success"
            borderRadius="lg"
            coloredShadow="success"
            mx={2}
            mt={-3}
            p={2}
            mb={1}
            textAlign="center"
          >
            <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
              Email Enviado
            </MDTypography>
          </MDBox>
          <MDBox pt={4} pb={3} px={3}>
            <MDTypography
              variant="h6"
              fontWeight="light"
              color="black"
              mt={1}
              textAlign="center"
            >
              Foi enviado um link para o email {reset.email} para criação de uma
              nova senha, verifique na sua caixa de Spam caso você não encontre
              o e-mail.
            </MDTypography>
          </MDBox>
        </Card>
      )}
    </BasicLayout>
  );
}

export default Password;
